module.exports = __webpack_public_path__ + "img/Lot12.f1136029.jpg";